import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { X, Loader2, Mail } from "lucide-react";

// Prepara una bozza Gmail con i PDF scelti in allegato. Lo studio la rilegge e la invia a mano.
export default function InviaFlussiDialog({ categoria, onClose }) {
  const [to, setTo] = useState("");
  const [oggetto, setOggetto] = useState(`Decreto Flussi 2027 — ${categoria.nome}`);
  const [testo, setTesto] = useState(
    "Buongiorno,\n\nin allegato le informazioni sul Decreto Flussi 2027 per la sua situazione.\n" +
    "Resto a disposizione per valutare insieme la pratica.\n\nCordiali saluti,\nRB Studio");
  const [scelti, setScelti] = useState(categoria.documenti.filter((d) => !d.interno).map((d) => d.file_id));
  const [invio, setInvio] = useState(false);

  const toggle = (id) => setScelti((s) => (s.includes(id) ? s.filter((x) => x !== id) : [...s, id]));

  const prepara = async () => {
    setInvio(true);
    try {
      const { data } = await api.post("/primo-piano/invia", { to, file_ids: scelti, oggetto, testo });
      toast.success(`Bozza pronta in Gmail con ${data.allegati} allegati — rileggila e invia da lì`);
      onClose();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Non riesco a preparare la bozza");
    } finally { setInvio(false); }
  };

  return (
    <div className="scheda-rb fixed inset-0 z-50 bg-[#1B2A4B]/45 flex items-start sm:items-center justify-center p-3 overflow-y-auto"
      data-testid="invia-flussi-dialog">
      <div className="dialogo w-full max-w-[560px] my-4">
        <div className="flex items-center justify-between gap-3 px-5 py-4 border-b border-[#E8E6DF]">
          <div className="min-w-0">
            <div className="eti">Invia a un potenziale cliente</div>
            <h3 className="text-[18px] font-bold text-[#1B2A4B] truncate">{categoria.nome}</h3>
          </div>
          <button data-testid="invia-flussi-chiudi" onClick={onClose} className="text-[#5A5A5A] hover:text-[#1A1A1A]">
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="p-5 flex flex-col gap-4">
          <label className="flex flex-col gap-1.5">
            <span className="eti">Email del destinatario</span>
            <input data-testid="invia-flussi-email" value={to} onChange={(e) => setTo(e.target.value)}
              placeholder="nome@esempio.com" className="campo" autoFocus />
          </label>

          <div className="sub">
            <div className="subt"><span>Allegati</span>
              <span className="text-[12px] font-normal normal-case tracking-normal text-[#5A5A5A]">{scelti.length} scelti</span>
            </div>
            {categoria.documenti.map((d) => (
              <label key={d.file_id} className="riga cursor-pointer hover:bg-[#FAFAF7]"
                data-testid={`invia-flussi-doc-${d.destinatario}`}>
                <input type="checkbox" checked={scelti.includes(d.file_id)} onChange={() => toggle(d.file_id)}
                  className="w-4 h-4 accent-[#1B2A4B]" />
                <span className="flex-grow min-w-0">
                  <span className="block truncate">{d.titolo}</span>
                  <span className="block text-[12px] text-[#5A5A5A]">{d.nota}</span>
                </span>
                {d.interno && <span className="tag bg-[#FDF6F1] text-[#9A3B13]">interno</span>}
              </label>
            ))}
          </div>

          <label className="flex flex-col gap-1.5">
            <span className="eti">Oggetto</span>
            <input data-testid="invia-flussi-oggetto" value={oggetto} onChange={(e) => setOggetto(e.target.value)} className="campo" />
          </label>
          <label className="flex flex-col gap-1.5">
            <span className="eti">Testo</span>
            <textarea data-testid="invia-flussi-testo" value={testo} onChange={(e) => setTesto(e.target.value)}
              rows={6} className="campo resize-y" />
          </label>
          <p className="text-[13px] text-[#4A4A48]">
            Creo solo la bozza nella tua Gmail: la rileggi e la invii tu.
          </p>
        </div>

        <div className="flex flex-wrap gap-2.5 px-5 py-4 border-t border-[#E8E6DF] bg-[#FAFAF7]">
          <button data-testid="invia-flussi-prepara" onClick={prepara}
            disabled={invio || !to.trim() || scelti.length === 0} className="btn btn-g btn-larghezza sm:w-auto">
            {invio ? <Loader2 className="w-4 h-4 animate-spin" /> : <Mail className="w-4 h-4" />}
            Prepara la bozza Gmail
          </button>
          <button data-testid="invia-flussi-annulla" onClick={onClose} className="btn btn-o btn-larghezza sm:w-auto">
            Annulla
          </button>
        </div>
      </div>
    </div>
  );
}
